import { createTheme } from "@mui/material/styles";

// A custom theme for this app
let Theme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#fff",
          color: "#2f2f2f",
        },
      },
    },
  },
  palette: {
    background: {
      default: "#ececec",
    },
    primary: {
      main: "#115C5b",
      // light: "#63ccff",
      // dark: "#006db3",
    },
    secondary: {
      main: "#C6A76E",
      // light: "#63ccff",
      // dark: "#006db3",
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Arial", sans-serif',
  },
});

export default Theme;
